import React from "react";

const Item = ({ emoji, selected }) => {
  return <div className={`item ${selected ? "selected" : ""}`}>{emoji}</div>;
};

export default Item;
